import React from "react";
import "./AgriculturalInsurance.css";
import { Link } from "react-router-dom";
import { GiWheat, GiCow, GiFarmTractor, GiBarn } from "react-icons/gi";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";

const covers = [
  { label: "Crops", Icon: GiWheat },
  { label: "Livestock", Icon: GiCow },
  { label: "Equipment", Icon: GiFarmTractor },
  { label: "Storage", Icon: GiBarn },
];

/**
 * AgriculturalInsurance Component
 * Announces the new Agricultural Insurance product on the products page
 * @returns a JSX element with the product headline, what it covers and how to get a quote
 */

function AgriculturalInsurance() {
  return (
    <div className="AgriculturalInsurance">
      <div className="AgriculturalInsurance_Top">
        <div className="AgriculturalInsurance_Badges">
          <span className="AgriculturalInsurance_New">New</span>
          <span className="AgriculturalInsurance_Tag">Agricultural Insurance</span>
        </div>
        <h1>
          Protect Your Farm. <br />
          <span>Secure Your Harvest.</span>
        </h1>
        <p>
          Drought, floods, pests or fire – don't let one bad season undo a year
          of hard work.
        </p>
        <div className="AgriculturalInsurance_Covers">
          {covers.map(({ label, Icon }) => (
            <div key={label}>
              <Icon />
              <p>{label}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="AgriculturalInsurance_Bottom">
        <h2>Get a quote today</h2>
        <div className="AgriculturalInsurance_Contacts">
          <div>
            <LocalPhoneIcon />
            <p>
              <a href="tel:+2204222476">4222476</a> / 833383885
            </p>
          </div>
          <div>
            <EmailIcon />
            <p>
              <a href="mailto:info@primeinsurancegambia.com">
                info@primeinsurancegambia.com
              </a>
            </p>
          </div>
        </div>
        <Link to="/contact" className="AgriculturalInsurance_Button">
          Contact Us
        </Link>
      </div>
    </div>
  );
}

export default AgriculturalInsurance;
